import { Component, OnInit, Input, NgZone } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { ModalController, AlertController } from '@ionic/angular';
import { Producto, ProductoPrecio } from '../../models/productoprecio';
import { SucursalService } from 'src/app/services/sucursal.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit {

  @Input() id: any;
  @Input() item: any;

  precio: ProductoPrecio[] = [];
  producto: Producto[] = [];

  quantity = 1;
  note = null;

  constructor(
    private sucursalAPI: SucursalService,
    private zone: NgZone,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public cartService: CartService
  ) {}

  ngOnInit() {
    this.showProduct(this.id, this.item);
  }

  showProduct(id, sucursal) {
    this.sucursalAPI.getSucursalProducto(id, sucursal).then((res: any) => {
      this.zone.run(() => {
        // this.detalle = res.data;
        this.producto = res.data;
        this.precio = res.data.precio;
      });
    });
  }

  toBack() {
    this.modalCtrl.dismiss();
  }

  resetData() {
    this.quantity = 1;
    this.note = null;
  }

  FunAgregarCantidad() {
    return (this.quantity += 1);
  }

  FunRestarCantidad() {
    return (this.quantity -= 1);
  }

  addToCart(product, quantity, note) {
    this.cartService.addProduct(product, quantity, null, note);
    this.modalCtrl.dismiss();
  }
}
